(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bobandi-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  var track = document.querySelector('[data-announce-track]');
  if (!track || track.children.length < 2) return;
  var idx = 0;
  var total = track.children.length;
  setInterval(function(){
    idx = (idx + 1) % total;
    track.style.transform = 'translateX(-' + (idx * 100) + '%)';
  }, 5000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var toggles = document.querySelectorAll('[data-bb-menu-toggle]');
  var nav = document.querySelector('[data-bb-mobile-nav]');
  var overlay = document.querySelector('.bb-header__overlay');
  if (!nav) return;
  function toggle(){
    nav.classList.toggle('is-open');
    if (overlay) overlay.classList.toggle('is-open');
    document.body.style.overflow = nav.classList.contains('is-open') ? 'hidden' : '';
  }
  toggles.forEach(function(el){ el.addEventListener('click', toggle); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-hero-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Thumbnails */
  var mainImg = document.getElementById('bb-main-img');
  var thumbs = document.querySelectorAll('[data-bb-thumb]');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      mainImg.src = t.dataset.imgSrc;
      thumbs.forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* Size pills */
  var pills = document.querySelectorAll('[data-bb-size]');
  pills.forEach(function(pill){
    pill.addEventListener('click', function(){
      pills.forEach(function(x){ x.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var label = document.querySelector('[data-bb-size-label]');
      if (label) label.textContent = pill.dataset.bbSize;
      updateVariant();
    });
  });

  /* Color swatches */
  var swatches = document.querySelectorAll('[data-bb-color]');
  swatches.forEach(function(sw){
    sw.addEventListener('click', function(){
      swatches.forEach(function(x){ x.classList.remove('is-active'); });
      sw.classList.add('is-active');
      var label = document.querySelector('[data-bb-color-label]');
      if (label) label.textContent = sw.dataset.bbColor;
      updateVariant();
    });
  });

  /* Update variant */
  function updateVariant(){
    var activePill = document.querySelector('[data-bb-size].is-active');
    var activeSwatch = document.querySelector('[data-bb-color].is-active');
    if (!activePill || !activeSwatch) return;
    var size = activePill.dataset.bbSize;
    var color = activeSwatch.dataset.bbColor;
    var url = window.location.pathname + '?variant=';
    /* Use Shopify's product JSON to find variant */
    fetch(window.location.pathname + '.js')
      .then(function(r){ return r.json(); })
      .then(function(product){
        var v = product.variants.find(function(v){
          return v.options.indexOf(size) > -1 && v.options.indexOf(color) > -1;
        });
        if (v) {
          var input = document.querySelector('[data-bb-variant-id]');
          if (input) input.value = v.id;
          var priceEl = document.querySelector('[data-bb-price]');
          if (priceEl) priceEl.textContent = (v.price / 100).toFixed(2).replace('.', ',') + ' zł';
          history.replaceState(null, '', window.location.pathname + '?variant=' + v.id);
        }
      });
  }

  /* Size chart modal */
  var chart = document.querySelector('[data-bb-size-chart]');
  var chartToggles = document.querySelectorAll('[data-bb-size-chart-toggle]');
  chartToggles.forEach(function(btn){
    btn.addEventListener('click', function(){
      chart.classList.toggle('is-open');
      document.body.style.overflow = chart.classList.contains('is-open') ? 'hidden' : '';
    });
  });

  /* Size finder */
  var findBtn = document.querySelector('[data-bb-find-size]');
  if (findBtn) {
    findBtn.addEventListener('click', function(){
      var band = document.querySelector('[data-bb-band]').value;
      var cup = document.querySelector('[data-bb-cup]').value;
      var result = document.querySelector('[data-bb-size-result]');
      if (!band || !cup) {
        result.textContent = 'Proszę wybrać obwód i miseczkę.';
        result.classList.add('is-visible');
        return;
      }
      result.textContent = 'Dla obwodu ' + band + ' i miseczki ' + cup + ' polecamy rozmiar ' + cup + '. Kliknij odpowiedni rozmiar powyżej.';
      result.classList.add('is-visible');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-results"] && !Shopify.designMode) return;
  try {
    
(function(){
  var findBtn = document.querySelector('[data-bb-res-find]');
  var output = document.querySelector('[data-bb-res-output]');
  if (findBtn && output) {
    findBtn.addEventListener('click', function(){
      var band = document.querySelector('[data-bb-res-band]').value;
      var cup = document.querySelector('[data-bb-res-cup]').value;
      if (!band || !cup) {
        output.textContent = 'Proszę wybrać obwód i miseczkę.';
      } else {
        output.textContent = 'Dla obwodu ' + band + ' i miseczki ' + cup + ' — Twój idealny rozmiar wkładki to: ' + cup + '. Wybierz go powyżej w sekcji produktu!';
      }
      output.classList.add('is-visible');
    });
  }

  var track = document.querySelector('.bb-results__track');
  var prev = document.querySelector('[data-bb-res-prev]');
  var next = document.querySelector('[data-bb-res-next]');
  if (track && prev && next) {
    prev.addEventListener('click', function(){ track.scrollBy({left:-300, behavior:'smooth'}); });
    next.addEventListener('click', function(){ track.scrollBy({left:300, behavior:'smooth'}); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobandi-video-tabs"] && !Shopify.designMode) return;
  try {
    
(function(){
  var btns = document.querySelectorAll('[data-bb-tab-btn]');
  var panels = document.querySelectorAll('[data-bb-tab-panel]');
  btns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var idx = btn.dataset.bbTabBtn;
      btns.forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-selected','false'); });
      panels.forEach(function(p){ p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected','true');
      var panel = document.querySelector('[data-bb-tab-panel="'+idx+'"]');
      if (panel) panel.classList.add('is-active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
